import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertPartsStopMutationVariables = Types.Exact<{
  stop: Types.Mobility_Stops_Insert_Input;
}>;


export type InsertPartsStopMutation = { __typename?: 'mutation_root', insert_mobility_stops_one?: { __typename?: 'mobility_stops', id: number, stop_order: number } | null };


export const InsertPartsStopDocument = gql`
    mutation insertPartsStop($stop: mobility_stops_insert_input!) {
  insert_mobility_stops_one(object: $stop) {
    id
    stop_order
  }
}
    `;
export type InsertPartsStopMutationFn = Apollo.MutationFunction<InsertPartsStopMutation, InsertPartsStopMutationVariables>;

/**
 * __useInsertPartsStopMutation__
 *
 * To run a mutation, you first call `useInsertPartsStopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPartsStopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPartsStopMutation, { data, loading, error }] = useInsertPartsStopMutation({
 *   variables: {
 *      stop: // value for 'stop'
 *   },
 * });
 */
export function useInsertPartsStopMutation(baseOptions?: Apollo.MutationHookOptions<InsertPartsStopMutation, InsertPartsStopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPartsStopMutation, InsertPartsStopMutationVariables>(InsertPartsStopDocument, options);
      }
export type InsertPartsStopMutationHookResult = ReturnType<typeof useInsertPartsStopMutation>;
export type InsertPartsStopMutationResult = Apollo.MutationResult<InsertPartsStopMutation>;
export type InsertPartsStopMutationOptions = Apollo.BaseMutationOptions<InsertPartsStopMutation, InsertPartsStopMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/insertPartsStop.mutation.gql}
 */
export async function insertPartsStop(
  variables: InsertPartsStopMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertPartsStopMutation['insert_mobility_stops_one']>
export async function insertPartsStop(
  variables: InsertPartsStopMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertPartsStopMutation>
export async function insertPartsStop(
  variables: InsertPartsStopMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertPartsStopMutation['insert_mobility_stops_one'] | InsertPartsStopMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertPartsStopMutation>(
    InsertPartsStopDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_mobility_stops_one
}